// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login-specific only. The shell, title and card geometry live in
   Components/PublicAuthShell.module.css, shared with the password screens. */

/* The card is flush (AuthCard flush), so the strip and the form each pad
   themselves -- same 14px x --card-pad, so their content lines up. */
.JOjN6Z_AOX4BjWakd6rL {
    padding: 14px var(--card-pad);
    border-bottom: 1px solid var(--mantine-color-gray-3);
    border-radius: var(--mantine-radius-md) var(--mantine-radius-md) 0 0;
}

.Ti8m7MtbFbi0ksZIhsCd {
    text-transform: uppercase;
    letter-spacing: 0.06em;
}

.IU_SuuCgsRA9VYoURjkE {
    font-family: var(--mantine-font-family-monospace);
}

/* Server flash messages carry real newlines — UserManager::login() emits
   "…has been disabled.\\n\\nInspection Support: <phone>" — which Mantine's Alert
   would otherwise collapse onto one line. */
.G9DL7PUV0FI1s2mRcLOq {
    padding: 14px var(--card-pad);
}

.AgLbNA0XTQg49NSOKScd {
    white-space: pre-line;
}

@media (max-width: 48em) {
    .JOjN6Z_AOX4BjWakd6rL {
        border-radius: 0;
    }

    /* 16px keeps iOS Safari from zooming the viewport on focus. */
    .G9DL7PUV0FI1s2mRcLOq {
        --input-height: 44px;
        --input-fz: 16px;
        --button-height: 44px;
        --button-fz: 15px;
    }
}
`, "",{"version":3,"sources":["webpack://./Pages/Login.module.css"],"names":[],"mappings":"AAAA;6EAC6E;;AAE7E;qEACqE;AACrE;IACI,6BAA6B;IAC7B,oDAAoD;IACpD,oEAAoE;AACxE;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,iDAAiD;AACrD;;AAEA;;4CAE4C;AAC5C;IACI,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA,8DAA8D;IAC9D;QACI,oBAAoB;QACpB,gBAAgB;QAChB,qBAAqB;QACrB,iBAAiB;IACrB;AACJ","sourcesContent":["/* Login-specific only. The shell, title and card geometry live in\n   Components/PublicAuthShell.module.css, shared with the password screens. */\n\n/* The card is flush (AuthCard flush), so the strip and the form each pad\n   themselves -- same 14px x --card-pad, so their content lines up. */\n.keystrip {\n    padding: 14px var(--card-pad);\n    border-bottom: 1px solid var(--mantine-color-gray-3);\n    border-radius: var(--mantine-radius-md) var(--mantine-radius-md) 0 0;\n}\n\n.keyLabel {\n    text-transform: uppercase;\n    letter-spacing: 0.06em;\n}\n\n.keyValue {\n    font-family: var(--mantine-font-family-monospace);\n}\n\n/* Server flash messages carry real newlines — UserManager::login() emits\n   \"…has been disabled.\\n\\nInspection Support: <phone>\" — which Mantine's Alert\n   would otherwise collapse onto one line. */\n.form {\n    padding: 14px var(--card-pad);\n}\n\n.alertBody {\n    white-space: pre-line;\n}\n\n@media (max-width: $mantine-breakpoint-sm) {\n    .keystrip {\n        border-radius: 0;\n    }\n\n    /* 16px keeps iOS Safari from zooming the viewport on focus. */\n    .form {\n        --input-height: 44px;\n        --input-fz: 16px;\n        --button-height: 44px;\n        --button-fz: 15px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"keystrip": `JOjN6Z_AOX4BjWakd6rL`,
	"keyLabel": `Ti8m7MtbFbi0ksZIhsCd`,
	"keyValue": `IU_SuuCgsRA9VYoURjkE`,
	"form": `G9DL7PUV0FI1s2mRcLOq`,
	"alertBody": `AgLbNA0XTQg49NSOKScd`
};
export default ___CSS_LOADER_EXPORT___;
